import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, CheckCircle2 } from "lucide-react";
import { BrandLogo } from "@/components/Brand";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) return setError("A senha precisa ter pelo menos 6 caracteres.");
    if (password !== confirm) return setError("As senhas não conferem.");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-cream">
      <div className="w-full max-w-md bg-white border border-border rounded-md p-8 animate-fade-up" data-testid="reset-password-page">
        <div className="mb-8">
          <BrandLogo className="h-11" />
        </div>
        {!token ? (
          <p className="text-sm text-destructive" data-testid="reset-missing-token">Link inválido. Peça um novo link em “Esqueci minha senha”.</p>
        ) : done ? (
          <div className="space-y-4" data-testid="reset-success">
            <CheckCircle2 className="w-10 h-10 text-gold" />
            <h2 className="font-heading text-2xl font-bold">Senha alterada!</h2>
            <p className="text-cappuccino text-sm">Agora é só entrar com a nova senha.</p>
            <Link to="/login" data-testid="reset-go-login">
              <Button className="w-full h-12 rounded-md bg-gold hover:bg-gold-hover text-white font-semibold mt-2">Ir para o login</Button>
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <h2 className="font-heading text-2xl font-bold">Criar nova senha</h2>
            <div>
              <Label htmlFor="np">Nova senha</Label>
              <Input id="np" type="password" data-testid="reset-password-input" value={password}
                onChange={(e) => setPassword(e.target.value)} required className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="cp">Confirmar nova senha</Label>
              <Input id="cp" type="password" data-testid="reset-confirm-input" value={confirm}
                onChange={(e) => setConfirm(e.target.value)} required className="mt-1.5" />
            </div>
            {error && <p data-testid="reset-error" className="text-sm text-destructive bg-destructive/10 rounded-md px-3 py-2">{error}</p>}
            <Button type="submit" data-testid="reset-submit" disabled={busy}
              className="w-full h-12 rounded-md bg-gold hover:bg-gold-hover text-white font-semibold">
              {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : "Salvar nova senha"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
